import { render } from "./LocalProposalStatus.vue?vue&type=template&id=18c7eb12"
import script from "./LocalProposalStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./LocalProposalStatus.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/LocalProposalStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18c7eb12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18c7eb12', __exports__)) {
    api.reload('18c7eb12', __exports__)
  }
  
  module.hot.accept("./LocalProposalStatus.vue?vue&type=template&id=18c7eb12", () => {
    api.rerender('18c7eb12', render)
  })

}


export default __exports__